class PianoProfile {
	constructor() {
		this.element = '.piano-profile';
		this.trigger = '.js-piano-profile-trigger';
		this.dropdown = '.piano-profile__dropdown';
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		const self = this;
		const $trigger = jQuery(this.element).find(this.trigger);
		$trigger.on('click', function () {
			self.handleClick(self);
		});

		jQuery(document).on('click', function (e) {
			if (jQuery(e.target).closest(self.element).length === 0) {
				self.closeDropdown();
			}
		});
	}

	handleClick(self) {
		if (
			jQuery(this.element).find(this.trigger).attr('aria-expanded') === 'false'
		) {
			self.openDropdown();
		} else {
			self.closeDropdown();
		}
	}

	openDropdown() {
		jQuery(this.element).find(this.trigger).attr('aria-expanded', true);
		jQuery(this.element).find(this.dropdown).attr('aria-hidden', false);
	}

	closeDropdown() {
		jQuery(this.element).find(this.trigger).attr('aria-expanded', false);
		jQuery(this.element).find(this.dropdown).attr('aria-hidden', true);
	}
}

const instance = new PianoProfile();
export default instance;
